import { Filter } from '@on3/ui-lib/components/Filter/Filter';
import { useDynamicRoute } from '@on3/ui-lib/utils/hooks/useDynamicRoute';
import clsx from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/router';

import styles from './HighSchoolNav.module.scss';

interface IHighSchoolNavProps {
  primaryColor?: string;
  type?: 'grid' | 'dropdown';
  className?: string;
}

export const HighSchoolNav = ({
  primaryColor,
  type = 'dropdown',
  className,
}: IHighSchoolNavProps) => {
  const router = useRouter();
  const { formatHref } = useDynamicRoute();
  const {
    id,
    year,
    sport = 'football',
  } = router.query as Record<string, string>;
  const scheduleRoute = year
    ? `/high-school/[id]/[sport]/[year]/schedule/`
    : `/high-school/[id]/[sport]/schedule/`;
  const rosterRoute = year
    ? `/high-school/[id]/[sport]/[year]/roster/`
    : `/high-school/[id]/[sport]/roster/`;

  const navItems = [
    { name: 'News', path: `/high-school/[id]/news/` },
    { name: 'Scores', path: `/high-school/[id]/[sport]/scores/` },
    { name: 'Schedule', path: scheduleRoute },
    { name: 'Roster', path: rosterRoute },
    { name: 'Alumni', path: `/high-school/[id]/[sport]/alumni/` },
  ];

  if (type === 'grid') {
    return (
      <div
        className={clsx(styles.block, styles.grid, className)}
        style={{ color: primaryColor }}
      >
        {navItems.map((item) => (
          <Link
            href={formatHref({
              path: item.path,
              params: { id, year, sport },
              options: { clearQuery: true },
            })}
            key={item.name}
          >
            {item.name}
          </Link>
        ))}
      </div>
    );
  }

  if (type === 'dropdown') {
    return (
      <Filter
        color={primaryColor}
        name="nav"
        navigate={(_, v) => v}
        options={navItems.map((item) => ({
          label: item.name,
          value: formatHref({
            path: item.path,
            params: { id, year, sport },
          }),
        }))}
        value={router.asPath}
      />
    );
  }

  return null;
};
